import { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const ApprovalModalForm = ({
  selectedItem,
  setSelectedItem,
  setOpenApprovalModal,
  fieldType,
  isLoading,
  onUpdate
}) => {
  const [reason, setReason] = useState("");

  const cancel = () => {
    setSelectedItem(null);
    setOpenApprovalModal(false);
  };


  return (
    <>
      <div className="kt_body">
          <>
            {selectedItem.type === "accept" ? (
              <div>
                <h4>
                  Are you sure you want to{" "}
                  <span style={{ color: "#2ecc71", fontWeight: 700 }}>
                    APPROVE
                  </span>{" "}
                  the {selectedItem.field_id ? fieldType(selectedItem.field_id)?.toLowerCase() : "Image"} for this listing
                </h4>
                <div className="text-center pt-5">
                  <button
                    type="reset"
                    onClick={() => cancel()}
                    className="btn btn-light me-3"
                    data-kt-users-modal-action="cancel"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn"
                    id="approve"
                    style={{ backgroundColor: "#2ecc71", color: "#fff" }}
                    data-kt-users-modal-action="submit"
                    disabled={isLoading}
                    onClick={() => {
                      onUpdate(true)
                    }}
                  >
                    <span className="indicator-label">APPROVE</span>
                  </button>
                </div>
              </div>
            ) : (
              <div>
                <h4>
                  Are you sure you want to{" "}
                  <span style={{ color: "#ed2626", fontWeight: 700 }}>
                    REJECT
                  </span>{" "}
                  the {selectedItem.field_id ? fieldType(selectedItem.field_id)?.toLowerCase() : "Image"} for this listing
                </h4>
                <div className="fv-row mb-3 mt-3">
                  <label className="required fw-bold fs-6 mb-1">Enter Reject Reason</label>
                <textarea
                    className="form-control form-control-solid w-100"
                    placeholder="Reject Reason (Min: 5 Characters & Max: 255 Characters)"
                    value={reason}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value.length <= 255) {
                        setReason(value);
                      }
                    }}
              />
              </div>
                <div className="text-center pt-5">
                  <button
                    type="reset"
                    onClick={() => cancel()}
                    className="btn btn-light me-3"
                    data-kt-users-modal-action="cancel"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn"
                    style={{ backgroundColor: "#ed2626", color: "#fff" }}
                    data-kt-users-modal-action="submit"
                    disabled={(!reason || reason.length < 5 || reason.length > 255) || isLoading}
                    onClick={() => {
                      onUpdate(false, reason)
                    }}
                  >
                    <span className="indicator-label">REJECT</span>
                  </button>
                </div>
              </div>
            )}
          </>
      </div>
    </>
  );
};

export { ApprovalModalForm };
